module.exports = __webpack_public_path__ + "images/emoji/clock1030.49f93de698be77c94215.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clock1030.png
// module id = 5blX
// module chunks = 24